import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import * as loaders from '../loader';

const VMind = lazy(async () => {
  const { VMind } = await import('../sites/vmind');
  return { default: VMind };
});

const VMindGuide = lazy(async () => {
  const { Guide } = await import('../sites/vmind/views/guide');
  return { default: Guide };
});

const VMindAPI = lazy(async () => {
  const { API } = await import('../sites/vmind/views/api');
  return { default: API };
});

const VMindScenario = lazy(async () => {
  const { Scenario } = await import('../sites/vmind/views/scenario');
  return { default: Scenario };
});

const VMindEntry = lazy(async () => {
  const { Entry } = await import('../sites/vmind/views/entry');
  return { default: Entry };
});

export const VMindRoutes: RouteObject[] = [
  {
    path: '/vmind',
    element: (
      <Suspense>
        <VMind />
      </Suspense>
    ),
  },
  {
    path: '/vmind/guide',
    loader: loaders.guideLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VMindGuide />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VMindGuide />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vmind/api',
    loader: loaders.apiLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VMindAPI />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VMindAPI />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vmind/scenario',
    loader: loaders.scenarioLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VMindScenario />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VMindScenario />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vmind/entry',
    loader: loaders.entryLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VMindEntry />
      </Suspense>
    ),
  },
];
